import { ComparePreset } from './datePicker/types';

// null cuando no hay base con la que comparar (periodo anterior a 0 o sin
// dato): la variación no está definida y no se muestra, en vez de ∞%.
const getDiff = (value: number, previousValue: number): number | null => {
  if(!previousValue || !Number.isFinite(previousValue) || !Number.isFinite(value)) {
    return null;
  }
  return Math.round(((value - previousValue) / Math.abs(previousValue)) * 100);
}

// Etiqueta junto al badge de Diff, en vez del "than last period" fijo de
// antes. 'custom' no tiene una regla nombrable, así que cae en el mismo
// texto genérico que 'prev-period'.
const getComparePresetLabel = (comparePreset?: ComparePreset): string => {
  switch(comparePreset) {
    case 'prev-month':
      return 'last month';
    case 'prev-quarter':
      return 'last quarter';
    case 'prev-year':
      return 'last year';
    default:
      return 'last period';
  }
}

export { getDiff, getComparePresetLabel };